import { Navigate } from "react-router-dom";
import { useAuthContext } from "../../context/context";
import LoadingCard from "../Cards/CardLoading";
import SubscriptionExpiredPopup from "./SubscriptionExpiredPopup";
import PropTypes from "prop-types";

const PrivateRoute = ({ element }) => {
  const { loggedIn, authStatus, userData } = useAuthContext();

  // Show loading state while checking auth
  if (authStatus === "loading") {
    return <LoadingCard title="Loading..." />;
  }

  // Redirect to login if not authenticated
  if (!loggedIn || authStatus === "failure") {
    return <Navigate to="/login" replace />;
  }

  // Show subscription popup if trial has expired and no active subscription
  if (userData && !userData.isTrialActive && !userData.hasActiveSubscription) {
    return (
      <>
        {element}
        <SubscriptionExpiredPopup />
      </>
    );
  }

  // If authenticated and subscription is valid, show the protected content
  return element;
};

PrivateRoute.propTypes = {
  element: PropTypes.node.isRequired,
};

export default PrivateRoute;
